import { DriveItem } from '@microsoft/microsoft-graph-types';
import { FC } from 'react';
import { DocumentIcon } from './DocumentIcon';
import { DocumentFavouriteButton } from './DocumentFavouriteButton';

interface DocumentDetailsProps {
  file: DriveItem;
}

export const DocumentDetails: FC<DocumentDetailsProps> = ({ file }) => {
  const fileName = file.name!;
  const splitFileName = fileName.split('.');
  const extension = splitFileName[splitFileName.length - 1];
  const fileNameToDisplay = fileName.substring(0, fileName.length - extension.length - 1);

  return (
    <div className="bg-primary-800 w-full px-3 py-2 flex items-center gap-4">
      <DocumentIcon fileName={fileName} />
      <div className="flex-1 overflow-hidden text-white">
        <p className="text-white font-semibold">{fileNameToDisplay}</p>
      </div>
      <DocumentFavouriteButton file={file} />
    </div>
  );
};
